import React from "react";
import { useSelector } from "react-redux";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
// import TripsIcon from "../../../Common/Svgs/TripsIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { tripData } from "../Data/TripDetailData";
// import SpeedLimit from "./SpeedLimit";

const Label = ({ text }) => {
  return (
    <p className="font-normal text-10 font-aileron text-dark-gray">{text}</p>
  );
};

const Value = ({ text, redirect, onClick, shouldCapitalize = true }) => {
  return (
    <div
      className={`flex items-center mt-2 gap-x-2 ${
        redirect && "cursor-pointer"
      }`}
      onClick={onClick}
    >
      <p
        className={`text-xs font-semibold text-black font-aileron whitespace-nowrap ${
          shouldCapitalize && "capitalize"
        } `}
      >
        {text}
      </p>
      {redirect ? <ChevronIcon className="w-4 h-4 stroke-dark-gray" /> : null}
    </div>
  );
};

const TripInformation = ({ tripChecklist = [] }) => {
  const { currentTrip } = useSelector((state) => state.trips);
  const { currentTrike } = useSelector((state) => state.trikes);

  const checklistPassed = tripChecklist?.filter((item) => item?.passed === 1);

  return (
    <div className="w-full h-full bg-white p-4 pb-8 border-[0.5px] border-light-grey rounded-md">
      <div className="flex justify-between">
        <div className="flex items-center gap-x-2.5">
          <CustomRoundedImage
            background="bg-primary"
            image={
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.6587 11.9866C9.60053 11.9866 11.9854 9.60182 11.9854 6.65998C11.9854 3.71814 9.60053 1.33331 6.6587 1.33331C3.71686 1.33331 1.33203 3.71814 1.33203 6.65998C1.33203 9.60182 3.71686 11.9866 6.6587 11.9866Z"
                  stroke="#FCFCFC"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.65234 13.2534C9.25234 14.1 10.2323 14.6534 11.3523 14.6534C13.1723 14.6534 14.6523 13.1734 14.6523 11.3534C14.6523 10.2467 14.1057 9.26669 13.2723 8.66669"
                  stroke="#FCFCFC"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.86797 9.33333H5.61948C5.72994 9.33333 5.81948 9.24379 5.81948 9.13333V7.60714C5.81948 7.54875 5.845 7.49328 5.88933 7.45529L6.07236 7.2984C6.16347 7.22031 6.30236 7.23947 6.36893 7.33931L7.6389 9.24427C7.67599 9.29991 7.73844 9.33333 7.80531 9.33333H8.2218C8.38388 9.33333 8.47865 9.15064 8.3853 9.01814L6.82552 6.80426C6.76949 6.72474 6.77881 6.61644 6.84759 6.54765L6.92131 6.47393C7.01002 6.38522 7.15757 6.39914 7.22812 6.50289L9.09329 9.2458C9.13053 9.30056 9.19246 9.33333 9.25868 9.33333H9.62581C9.78591 9.33333 9.88111 9.15459 9.79178 9.02173L7.72953 5.9548C7.67616 5.87543 7.68645 5.7694 7.75407 5.70177L9.11443 4.34142C9.24042 4.21543 9.15119 4 8.973 4H8.0825C8.03043 4 7.98042 4.02031 7.94308 4.0566L6.1589 5.79122C6.03212 5.91449 5.81948 5.82465 5.81948 5.64783V4.2C5.81948 4.08954 5.72994 4 5.61948 4H4.86797C4.75751 4 4.66797 4.08954 4.66797 4.2V9.13333C4.66797 9.24379 4.75751 9.33333 4.86797 9.33333Z"
                  fill="#FCFCFC"
                />
              </svg>
            }
          />

          <p className="text-base font-medium capitalize font-poppins">
            Commission
          </p>
        </div>
        {/* <SpeedLimit /> */}
      </div>

      <div className="flex justify-between">
        <div>
          <div className=" mt-6 ml-12 flex gap-x-[95px] gap-y-6">
            {tripData(
              currentTrip,
              currentTrike,
              checklistPassed?.length,
              tripChecklist.length,
            )
              .slice(0, 3)
              .map((item) => (
                <div className="w-[137px]" key={item.id}>
                  <Label text={item.label} />

                  <Value
                    id={item.id}
                    text={item.value}
                    redirect={item.redirect}
                    onClick={item?.onClick}
                    shouldCapitalize={item.id !== 3}
                  />
                </div>
              ))}
          </div>

          <div className="mt-6 ml-12 flex gap-x-[95px]">
            {tripData(
              currentTrip,
              currentTrike,
              checklistPassed?.length,
              tripChecklist.length,
            )
              .slice(3, 6)
              .map((item) => (
                <div className="w-[137px]" key={item.id}>
                  <Label text={item.label} />

                  <Value
                    id={item.id}
                    text={item.value}
                    redirect={item.redirect}
                    onClick={item?.onClick}
                  />
                </div>
              ))}

            {/* empty div to ensure layout consistency (removed total trip duration from row 1) */}
            {/* <div className="w-[137px]" /> */}
          </div>
        </div>
        <div className="bg-green-10 rounded-md px-11 flex flex-col gap-2 pr-8 mt-[20px] justify-center h-[93px]">
          <span className="font-aileron font-semibold text-xs leading-none">
            Total Commission
          </span>
          <span className="font-poppins font-medium text-base leading-none text-black">
            431 Ksh
          </span>
        </div>
      </div>
    </div>
  );
};

export default TripInformation;
